import type { Nullable, User } from "@msuite/utils/types";
import { authClient } from "@/api/auth";
import { useCitadel } from "./use-citadel";

export function useAuth() {
	const session = authClient.useSession();
	const { citadel, ...citadelQuery } = useCitadel();
	const organizations = authClient.useListOrganizations();

	/** Functions */
	async function refetch() {
		await session?.refetch();
	}

	/** Computed */
	const user = session.data?.user as Nullable<User>;

	const isSignedIn = !!session.data?.user;
	const organization = {
		id: session.data?.session?.activeOrganizationId,
		orgId: session.data?.session?.activeOrganizationId,
	};
	const refetchAuth = refetch;

	return {
		organization,
		organizations,
		user,
		isSignedIn,
		session,
		citadel,
		citadelQuery,
		refetch,
		/**
		 * Alternative incase refetch is already used in the file.
		 */
		refetchAuth,
	};
}
